import React from 'react';
import PropTypes from 'prop-types';
import { FormSection, Field } from 'redux-form';
import { Checkbox } from 'redux-form-material-ui';

const listRender = (listPacks, packs) =>
    listPacks.map(packId => {
        const pack = packs[packId];

        return (
            <Field
                key={packId}
                name={pack.id}
                label={pack.name}
                normalize={v => Boolean(v)}
                type="checkbox"
                component={Checkbox}
            />
        );
    });

function PacksForm({ packs = {}, listPacks = [], ListWrapper }) {
    return (
        <FormSection name="accountPacks">
            {ListWrapper ? <ListWrapper>{listRender(listPacks, packs)}</ListWrapper> : listRender(listPacks, packs)}
        </FormSection>
    );
}

PacksForm.propTypes = {
    packs: PropTypes.object.isRequired,
    listPacks: PropTypes.array.isRequired,
    ListWrapper: PropTypes.func
};

export default PacksForm;



/** WEBPACK FOOTER **
 ** ../src/dash/front/admin/components/Account/forms/PacksForm.js
 **/